export default "__VITE_ASSET__B36cOt9A__"